module.exports = __webpack_public_path__ + "img/banner-finantare_alt.95e57080.png";